// extracted by mini-css-extract-plugin
module.exports = {"section18":"Section18_section18__pWsYE"};